'use client';

import { AspectRatio } from '@/components/ui/aspect-ratio';

export default function LoadingScreen() {
  return (
    <div className='flex h-screen items-center justify-center'>
      <div className='max-w-lg'>
        <AspectRatio ratio={3 / 2} className='object-cover'>
          <video
            className='rounded-2xl object-cover h-full'
            autoPlay
            loop
            muted
            playsInline
            onContextMenu={(e) => e.preventDefault()}
            style={{ pointerEvents: 'none' }}
          >
            <source
              src={
                process.env.NEXT_PUBLIC_CLOUDFRONT_URL + '/assets/home-hero.mp4'
              }
              type='video/mp4'
            />
            Your browser does not support the video tag.
          </video>
        </AspectRatio>
      </div>
    </div>
  );
}
